<template>
  <section>
    <!--Cabeçalho de consulta-->
    <el-col :span="24" class="toolbar" style="padding-bottom: 0px;">
      <el-form size="mini">
        <el-form-item>
          <el-button type="primary" icon="el-icon-plus" @click.native.prevent="showDialogInsert()">Novo
            Usuário</el-button>
        </el-form-item>
      </el-form>
    </el-col>
    <!--Tabela de dados-->
    <el-table stripe size=small ref="tableData" :data=listaUsers v-loading=listLoading empty-text=' '
      style="width: 100%;">
      <el-table-column label="Ativo" width="55" align=center>
        <template slot-scope="scope">
          <el-tag size='mini' type="success" disable-transitions v-if="scope.row.ativo === 'S'">Sim</el-tag>
          <el-tag size='mini' type="danger" disable-transitions v-if="scope.row.ativo === 'N'">Não</el-tag>
        </template>
      </el-table-column>
      <el-table-column label="Role" width="70" align=center>
        <template slot-scope="scope">
          <el-tag size='mini' type="primary" disable-transitions v-if="scope.row.admin === 'S'">Admin</el-tag>
          <el-tag size='mini' type="info" disable-transitions v-if="scope.row.admin === 'N'">User</el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="login" label="Login">
      </el-table-column>
      <el-table-column prop="nome" label="Nome">
      </el-table-column>
      <el-table-column prop="email" label="Email">
      </el-table-column>
      <el-table-column prop="cliente" label="Cliente">
      </el-table-column>
      <el-table-column label="Ações" width="140" align=center>
        <template slot-scope="users">
          <el-tooltip class="item" effect="dark" content="Resetar senha do usuário" placement="bottom">
            <el-button plain type="primary" size=small icon="fa fa-key" circle
              @click.native="showDialogPassword(users.row)"></el-button>
          </el-tooltip>
          <el-tooltip class="item" effect="dark" content="Editar usuário" placement="bottom">
            <el-button plain type="primary" size=small icon="fa fa-pencil" circle
              @click.native="showDialogEdit(users.row)"></el-button>
          </el-tooltip>
          <el-tooltip class="item" effect="dark" content="Excluir usuário" placement="bottom">
            <el-button plain type="danger" size=small icon="fa fa-trash" circle
              @click.native="deleteUser(users.row.id, users.row.login, users.row.nome)"></el-button>
          </el-tooltip>
        </template>
      </el-table-column>
    </el-table>
    <el-col :span="24" class="toolbar">
      <el-pagination layout="sizes, prev, pager, next, total" @current-change="handleCurrentChange"
        @size-change="handleSizeChange" :page-size="pageSize" :total="totalReg" :page-sizes="[5, 10, 15, 20, 25, 30]"
        style="float:right;">
      </el-pagination>
    </el-col>
    <!-- Dialog responsavel por mostrar o form de inclusao/alteracao do cadastro de usuarios -->
    <el-dialog v-if="dialogCreated" title="Cadastro do usuário" :show-close="false" :visible.sync="dialogVisible">
      <el-form ref="formUsers" :model="formUsers" label-width="100px" size="small">
        <el-col :span="12">
          <el-form-item label="Cliente">
            <el-select :disabled="this.formUsers.insert == false" auto-complete="nops" style="width:100%" filterable
              v-model="formUsers.clientesSel" placeholder="Selecione o cliente">
              <el-option v-for="item in formUsers.clientesObj" :key="item.cnpjRaiz" :label="item.razaoSocial"
                :value="item.cnpjRaiz">
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="Login">
            <el-input :disabled="this.formUsers.insert == false" auto-complete="nops" v-model="formUsers.login"
              clearable></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="Senha" v-if="this.formUsers.insert == true">
            <el-input type="password" auto-complete="nops" v-model="formUsers.newPassword" clearable></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="Confirmação" v-if="this.formUsers.insert == true">
            <el-input type="password" auto-complete="nops" v-model="formUsers.confirmPassword" clearable></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="Nome">
            <el-input auto-complete="nops" v-model="formUsers.nome" clearable></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="E-mail">
            <el-input auto-complete="nops" v-model="formUsers.email" clearable></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="Role">
            <el-radio-group v-model="formUsers.admin">
              <el-radio-button label="S">Admin</el-radio-button>
              <el-radio-button label="N">User</el-radio-button>
            </el-radio-group>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="Usuário ativo">
            <el-switch :disabled="this.formUsers.insert == true" inactive-color="#ff4949" v-model="formUsers.ativo"
              active-value="S" inactive-value="N">
            </el-switch>
          </el-form-item>
        </el-col>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button size="medium" @click="hideDialog">Cancelar</el-button>
        <!-- <el-button size="medium" type="primary" :loading=formUsers.sendLoading @click="sendEmailNfe('formUsers')">Salvar</el-button> -->
        <el-button size="medium" type="primary" :loading=formUsers.sendLoading
          @click="saveClient(formUsers)">Salvar</el-button>
      </span>
    </el-dialog>

    <!-- Dialog responsavel por mostrar o form de reset de senha -->
    <el-dialog v-if="dialogPasswordCreated" title="Reset da senha do usuário" :show-close="false"
      :visible.sync="dialogPasswordVisible" width="40%">
      <el-form ref="formPassword" :model="formPassword" label-width="160px" size="mini">
        <el-form-item label="Login">
          <el-input v-model="formPassword.login" :disabled="true"></el-input>
        </el-form-item>

        <el-form-item label="Nova Senha">
          <!-- Foi utilizada string "nops" no auto-complete pois o chrome ignora quando informado "off" -->
          <el-input type="password" v-model="formPassword.newPassword" auto-complete="nops" clearable></el-input>
        </el-form-item>

        <el-form-item label="Confirme a Senha">
          <!-- Foi utilizada string "nops" no auto-complete pois o chrome ignora quando informado "off" -->
          <el-input type="password" v-model="formPassword.confirmNewPassword" auto-complete="nops" clearable></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button size="medium" @click="hideDialogPassword">Cancelar</el-button>
        <el-button size="medium" type="primary" :loading=formPassword.sendLoading
          @click.native="resetPassword(formPassword)">Confirmar</el-button>
      </span>
    </el-dialog>

  </section>
</template>

<script>
import { Message } from "element-ui";
import { mask } from "vue-the-mask"; // https://vuejs-tips.github.io/vue-the-mask/
import { apiResetPassword, apiGetClientesForUsers, apiGetUsers, apiDeleteUser, apiUpdateUser, apiInsertUser } from "../../api/api";

// Clona um objeto
const cloneObj = (obj) => {
  if (null == obj || "object" != typeof obj) return obj;
  var copy = obj.constructor();
  for (var attr in obj) {
    if (obj.hasOwnProperty(attr)) copy[attr] = obj[attr];
  }
  return copy;
}

export default {
  name: "usuarios",
  components: {},
  directives: {
    mask
  },
  data () {
    return {
      listaUsers: [],
      pageNumber: 1,
      pageSize: 10,
      totalReg: 0,
      listLoading: false,
      dialogVisible: false,
      dialogCreated: true,
      dialogPasswordVisible: false,
      dialogPasswordCreated: true,
      formUsers: {
        insert: true,
        id: '',
        cnpjRaiz: '',
        login: '',
        nome: '',
        email: '',
        ativo: 'S',
        admin: 'N',
        sendLoading: false,
        clientesObj: [],
        clientesSel: "",
        newPassword: '',
        confirmPassword: ''
      },
      formPassword: {
        id: '',
        login: '',
        newPassword: '',
        confirmNewPassword: '',
        sendLoading: false
      }
    };
  },

  methods: {
    showDialogEdit (row) {
      this.formUsers.insert = false;
      this.formUsers.id = row.id;
      this.formUsers.cnpjRaiz = row.cnpjRaiz;
      this.formUsers.login = row.login;
      this.formUsers.nome = row.nome;
      this.formUsers.email = row.email;
      this.formUsers.ativo = row.ativo;
      this.formUsers.admin = row.admin;
      this.formUsers.clientesSel = row.cnpjRaiz;

      this.dialogCreated = true;
      this.dialogVisible = true;
    },
    showDialogInsert () {
      apiGetClientesForUsers()
        .then(data => {
          this.formUsers.clientesObj = data;
          // this.formUsers.clientesSel = data[Object.keys(data)[0]].cnpjRaiz;
        })
        .catch(error => { console.log('error: ' + error) });
      this.formUsers.insert = true;
      this.formUsers.id = 0;
      this.formUsers.cnpjRaiz = '';
      this.formUsers.login = '';
      this.formUsers.nome = '';
      this.formUsers.email = '';
      this.formUsers.ativo = 'S';
      this.formUsers.admin = 'N';
      this.formUsers.clientesSel = '';
      this.formUsers.newPassword = '';
      this.formUsers.confirmPassword = '';
      this.dialogCreated = true;
      this.dialogVisible = true;
    },
    hideDialog () {
      this.dialogVisible = false;
      this.dialogCreated = false;
    },
    showDialogPassword (row) {
      this.formPassword.id = row.id;
      this.formPassword.login = row.login;
      this.formPassword.newPassword = '';
      this.formPassword.confirmNewPassword = '';

      this.dialogPasswordCreated = true;
      this.dialogPasswordVisible = true;
    },
    hideDialogPassword () {
      this.dialogPasswordVisible = false;
      this.dialogPasswordCreated = false;
    },
    handleCurrentChange (val) {
      this.pageNumber = val;
      this.getUsers(this.pageNumber, this.pageSize);
    },
    handleSizeChange (val) {
      this.pageSize = val;
      this.getUsers(this.pageNumber, this.pageSize);
    },
    getUsers (pageNumber, pageSize) {
      this.listLoading = true;
      const params = {}
      if ((pageSize) && (pageNumber)) {
        params["limit"] = pageSize
        params["page"] = pageNumber
      } else {
        params["limit"] = this.pageSize
        params["page"] = this.pageNumber
      }
      apiGetUsers(params)
        .then(res => {
          this.listaUsers = res.usuarios;
          this.totalReg = parseInt(res.totalReg);
          this.listLoading = false;
        })
        .catch(error => {
          this.listLoading = false;
        });
    },
    deleteUser (id, login, nome) {
      this.$confirm("<strong>" + login + " - " + nome + "</strong><br><br>" +
        "Tem certeza que deseja excluir o usuário selecionado?", "Excluir Usuário", {
        type: 'warning', dangerouslyUseHTMLString: true
      })
        .then(() => {
          apiDeleteUser(id)
            .then(res => {
              Message.success('Usuário excluído com sucesso!');
              this.getUsers()
            })
            .catch(error => {
              Message.error('Não foi possível excluir o usuário!');
              this.listLoading = false;
            });
        })
        .catch(() => { });
    },
    saveClient (form) {
      this.formUsers.sendLoading = true
      const params = cloneObj(form)

      if (params.clientesSel) {
        params['cnpjRaiz'] = params.clientesSel
          .replace(/\./g, "")
          .replace(/\-/g, "")
          .replace(/\//g, "");
      } else {
        params['cnpjRaiz'] = "0"
      }
      // remove chaves desnecessarias
      delete params.clientesObj
      delete params.clientesSel
      delete params.sendLoading
      delete params.insert
      if (form.insert == true) {
        apiInsertUser(params)
          .then(data => {
            this.formUsers.sendLoading = false
            Message.success('Usuário incluído com sucesso!');
            this.getUsers()
            this.hideDialog()
          })
          .catch(error => {
            console.log('error: ' + error)
            this.formUsers.sendLoading = false
          });
      } else {
        delete params.newPassword
        delete params.confirmPassword

        apiUpdateUser(params['id'], params)
          .then(data => {
            this.formUsers.sendLoading = false
            Message.success('Usuário atualizado com sucesso!');
            this.getUsers()
            this.hideDialog()
          })
          .catch(error => {
            console.log('error: ' + error)
            this.formUsers.sendLoading = false
          });
      }
    },
    resetPassword (form) {
      // Message.warning('Ação ainda não disponível!' + id);
      this.formPassword.sendLoading = true
      // const id = form.id
      const params = cloneObj(form)
      // remove chaves desnecessarias
      // delete params.id
      delete params.login

      apiResetPassword(params)
        .then(res => {
          this.formPassword.sendLoading = false;
          Message.success(res.message);
          this.hideDialogPassword();
        })
        .catch(error => {
          this.formPassword.sendLoading = false;
        });

    }
  },
  mounted () {
    this.getUsers();

    // apiGetClientesForUsers()
    //   .then(data => {
    //     this.formUsers.clientesObj = data;
    //     this.formUsers.clientesSel = data[Object.keys(data)[0]].cnpjRaiz;
    //   })
    //   .catch(error => { console.log('error: ' + error) });
  }
};
</script>

<style></style>


// WEBPACK FOOTER //
// src/views/admin/users.vue